import { RouteConfig } from 'react-router-config';
import routesLp from './routes-lp';

// TODO: Need fixed as any
const routesPublic: RouteConfig[] = [...routesLp] as any;

export default routesPublic;
